import { Box, Grid } from "@mui/material"

export const Tfooter = ({salesBranchList}) => {

    let totalsales = salesBranchList.reduce((prev, current) => {
        if (current.total_sales == null) return prev;
        return prev + +current.total_sales;
    }, 0);
    let totaladjustedsales = salesBranchList.reduce((prev, current) => {
        if (current.adjusted_total_sales == null) return prev;
        return prev + +current.adjusted_total_sales;
    }, 0);
    let totalactualsales = salesBranchList.reduce((prev, current) => {
        if (current.actual_sales == null) return prev;
        return prev + +current.actual_sales;
    }, 0);
    let totalvariance = salesBranchList.reduce((prev, current) => {
        if (current.variance == null) return prev;
        return prev + +current.variance;
    }, 0);
    
    return (
        <Box minHeight="70px">
            <Grid container direction="row" sx={{ py:1.5, px:2}}>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2} textAlign="center"></Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totaladjustedsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalactualsales).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>{`₱ ${parseFloat(totalvariance).toLocaleString('en-PH', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`}</Grid>
            </Grid>
            <Grid container direction="row" sx={{ px:2}}>
                <Grid item xs={2}></Grid>
                <Grid item xs={2}></Grid>
                <Grid item xs={2} textAlign="center"></Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>Total Sales</Grid>
                <Grid item xs={2} textAlign="center" fontWeight={700}>Total Adjusted Total Sales</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>Total Actual Sales</Grid>
                <Grid item xs={1} textAlign="center" fontWeight={700}>Total Variance</Grid>
            </Grid>
        </Box>
    )
}